/* ==========================================================================
   Variant promo badge — swaps the text when the selected variant changes.
   Markup + data: snippets/product-promo-label.liquid ([data-promo-label] and a
   JSON map variant id → text). Loaded by sections/main-product.liquid.

   This product form has no single variant event to hook into:
   - the size picker (bt-libs.js) writes the id into `.product_variant_id` with
     jQuery .val() — no change event, no attribute change, no URL update;
   - other pickers (bt-product-global.js) set `.variant-id` and fire a
     jQuery-only `change`;
   - the form's `no-js` select is a render-time fallback and goes stale.
   So, like the subscription widget on the same form
   (snippets/custom-subscription-widget.liquid), this re-reads the live id
   field after picker clicks (delegated, a few short delays because the picker
   can refetch the product), on jQuery/native `change` and on `popstate`, and
   updates the badge only when the id actually changes. An empty value hides
   the badge.
   ========================================================================== */
(function () {
  'use strict';

  if (window.pgPromoLabelLoaded) return;
  window.pgPromoLabelLoaded = true;

  var PICKER = '.pg__option, .product-group-variants, .swatch, [data-index], .cef-variants';

  function valuesFor(label) {
    if (!label.pgPromoValues) {
      var data = label.parentNode && label.parentNode.querySelector('script[data-promo-label-map]');
      try {
        label.pgPromoValues = data ? JSON.parse(data.textContent) : {};
      } catch (error) {
        label.pgPromoValues = {};
      }
    }
    return label.pgPromoValues;
  }

  // The fields the theme keeps current come first; the no-js select last.
  function liveVariantId(scope) {
    var fields = scope.querySelectorAll('.product_variant_id, .variant-id, [name="id"]');
    var stale = '';
    for (var i = 0; i < fields.length; i++) {
      var field = fields[i];
      if (!field.value || field.classList.contains('variant-id--compare')) continue;
      if (field.classList.contains('no-js')) {
        stale = stale || String(field.value);
        continue;
      }
      return String(field.value);
    }
    return stale;
  }

  function sectionsWithBadge() {
    var labels = document.querySelectorAll('[data-promo-label]');
    var scopes = [];
    for (var i = 0; i < labels.length; i++) {
      var scope = labels[i].closest('.shopify-section') || document.body;
      if (scopes.indexOf(scope) === -1) scopes.push(scope);
    }
    return scopes;
  }

  function check(scope) {
    var variantId = liveVariantId(scope);
    if (!variantId || variantId === scope.pgPromoVariant) return;
    scope.pgPromoVariant = variantId;

    var labels = scope.querySelectorAll('[data-promo-label]');
    for (var i = 0; i < labels.length; i++) {
      var values = valuesFor(labels[i]);
      if (!Object.prototype.hasOwnProperty.call(values, variantId)) continue;
      var text = String(values[variantId] || '').trim();
      labels[i].textContent = text;
      labels[i].hidden = !text;
    }
  }

  function checkAll() {
    sectionsWithBadge().forEach(check);
  }

  function checkSoon() {
    [0, 60, 160, 360, 700].forEach(function (delay) {
      setTimeout(checkAll, delay);
    });
  }

  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest && event.target.closest(PICKER)) checkSoon();
  }, true);

  document.addEventListener('change', checkSoon, true);
  window.addEventListener('popstate', checkSoon);

  // bt-product-global.js announces its switch with a jQuery-only change event.
  if (window.jQuery) window.jQuery(document).on('change', '.variant-id', checkSoon);

  function init() {
    // The badge is rendered for the right variant server-side; this only
    // records the starting id so later checks compare against it.
    sectionsWithBadge().forEach(function (scope) {
      scope.pgPromoVariant = liveVariantId(scope);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', checkSoon);
})();
